
import {Component, Watch} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import PasswordMixin from '@/mixins/PasswordMixin';

@Component
export default class PasswordSnackbar extends mixins(PasswordMixin) {
  show = false;
  text = '';

  @Watch('$route.path')
  onRouteChanged() {
    this.passwordNotification();
  }

  mounted() {
    this.passwordNotification();
  }

  passwordNotification() {
    if (this.differentDatePassword > 76 && this.differentDatePassword < 90) {
      this.show = true;
      this.text = 'is expiring';
    } else if (this.differentDatePassword >= 90) {
      this.show = true;
      this.text = 'has expired';
    }
  }
}
